import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BlockMath } from "react-katex";
import api from "@/lib/api";
import Mashy from "@/components/Mashy";

export default function MathPractice() {
  const nav = useNavigate();
  const [lessons, setLessons] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/lessons", { params: { subject: "math" } }).then((r) => {
      setLessons(r.data.lessons || []);
      setActive((r.data.lessons || [])[0] || null);
    });
  }, []);

  return (
    <div className="min-h-screen bg-[#F7F9FC] pb-24" data-testid="math-screen">
      <header className="px-5 pt-6 max-w-xl mx-auto">
        <div className="text-xs font-bold uppercase tracking-widest text-gray-500">Math Practice</div>
        <h1 className="font-display text-2xl">Numbers ke superhero bano!</h1>
      </header>

      <main className="max-w-xl mx-auto px-5 mt-5 flex flex-col gap-5">
        <div className="card-chunky p-5">
          <div className="flex items-center gap-3">
            <Mashy mood="happy" size={64} bounce={false} />
            <div>
              <div className="text-xs font-bold uppercase tracking-widest text-gray-500">Today's Topics</div>
              <div className="font-display text-lg">Arithmetic • Fractions • Word Problems</div>
            </div>
          </div>
        </div>

        {active && (
          <div className="card-chunky p-5" data-testid="math-active-preview">
            <div className="text-xs font-bold uppercase tracking-widest text-gray-500">Preview</div>
            <div className="font-display text-xl mt-1">{active.title}</div>
            {active.content?.latex ? (
              <div className="my-3"><BlockMath math={active.content.latex} /></div>
            ) : (
              <div className="text-lg mt-2">{active.content?.question}</div>
            )}
            <button onClick={() => nav(`/lesson/${active.lesson_id}`)} data-testid="math-start-active" className="btn-success mt-3 w-full">
              Solve it
            </button>
          </div>
        )}

        <div>
          <div className="font-display text-lg mb-2">All Math Lessons</div>
          <div className="grid grid-cols-1 gap-3">
            {lessons.map((l) => (
              <button key={l.lesson_id} onClick={() => setActive(l)} data-testid={`math-lesson-${l.lesson_id}`}
                className={`card-chunky p-4 text-left transition-all ${active?.lesson_id === l.lesson_id ? "border-[#1CB0F6] border-2" : ""}`}>
                <div className="font-display text-base">{l.title}</div>
                <div className="text-xs text-gray-500 font-bold uppercase tracking-wider">{l.topic} • {l.difficulty}</div>
              </button>
            ))}
            {lessons.length === 0 && <div className="text-gray-500 text-sm">No math lessons yet — check back soon!</div>}
          </div>
        </div>
      </main>
    </div>
  );
}
